import project01 from "./../img/projects/prod01.jpg";
import project02 from "./../img/projects/prod02.jpg";



const projects = [
    {
        id: "0",
        title: 'Burger Market',
        skills: 'React, HTML, CSS',
        img: project01,
        imgBig: project01,
        imgHref:"https://onyxlotus.github.io/dep_burger/",
        gitHubLink: 'https://github.com/Onyxlotus/dep_burger',
    },
    {
        id: "1",
        title: 'Music player (coming soon)',
        skills: 'React',
        img: project02,
        imgBig: project02,
        imgHref:"",
        gitHubLink: 'https://github.com/Onyxlotus/musicplayer',
    },     
];

export {projects}